// Selectors / IDs for the host-page elements the widget reads
// configuration from (data-* attributes such as data-user-id,
// data-registration-date, data-language).

// OSW: customers attach attributes to a custom button element with an
// id that starts with `unibo-osw-custom-`.
export const OSW_BUTTON_SELECTOR = '[id^="unibo-osw-custom-"]';

// IGW: customers mark the container that wraps the game. We support
// two markers, in priority order:
//
//   1. `data-unibo-gameframe` — preferred. Doesn't collide with the
//      client's existing id on that element.
//   2. `id="gameframe"`        — legacy. Kept for backward compat
//      (barebet / early integrations).
//
// The IGW entry script uses these same selectors to locate the mount
// point, so the data-* attribute lookup and the mount lookup stay
// consistent regardless of which marker the client chose.
export const IGW_GAMEFRAME_DATA_ATTR = "data-unibo-gameframe";
export const IGW_GAMEFRAME_DATA_SELECTOR = `[${IGW_GAMEFRAME_DATA_ATTR}]`;
export const IGW_GAMEFRAME_LEGACY_ID = "gameframe";
export const IGW_GAMEFRAME_LEGACY_SELECTOR = `#${IGW_GAMEFRAME_LEGACY_ID}`;

// Combined selector — first match wins. Use this when locating the
// gameframe element from anywhere in the codebase.
export const IGW_GAMEFRAME_SELECTOR = `${IGW_GAMEFRAME_DATA_SELECTOR}, ${IGW_GAMEFRAME_LEGACY_SELECTOR}`;
